
(function(){
  "use strict";

  if (window.__PO_K5_EKHO_TRILANG_20260401__) return;
  window.__PO_K5_EKHO_TRILANG_20260401__ = true;

  var STORAGE_KEY = "po_k5_ekho_lang";
  var DEFAULT_LANG = "FR";

  var URLS = {
    lexicon: "https://goodyart.store/pages/lexique-simplifie/",
    ekho: "https://goodyart.store/pages/ekho",
    katuvys: "https://goodyart.store/pages/katuvys",
    katusys: "https://goodyart.store/pages/katusys",
    usoprogalenmestud: "https://goodyart.store/pages/usoprogalenmestud",
    katuvysissence: "https://goodyart.store/pages/katuvysissence",
    lulaesirasen: "https://goodyart.store/pages/lulaesirasen",
    taxielis: "https://goodyart.store/pages/taxielis",
    tiqqunbahu: "https://goodyart.store/pages/tiqqunbahu",
    takimarah: "https://goodyart.store/pages/takimarah",
    extratinrieur: "https://goodyart.store/pages/extratinrieur",
    mathesis: "https://goodyart.store/pages/mathesis-ontologique-posoennoiale",

    title: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195",
    ekho: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195",
    katuvys_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535",
    katusys_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katusys_copie.png?v=1772885244",

    usoprogalenmestud_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Usoprogalenmestud_copie.png?v=1772885484",
    usoprogalenmestud_freq: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/nombre_guide_225.png?v=1773409871",

    katuvysissence_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvysissence_copie.png?v=1772885892",
    katuvysissence_freq: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_193.png?v=1773410300",

    lulaesirasen_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Lulae_irasen_copie_2.png?v=1772886087",
    lulaesirasen_freq: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_136.png?v=1773410991",

    taxielis_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Taxielis_copie_2.png?v=1772886281",
    taxielis_freq: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_99.png?v=1773410839",

    tiqqunbahu_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Tiqqunbahu_copie_2.png?v=1772886448",
    tiqqunbahu_freq: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_130.png?v=1773410721",

    takimarah_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Takimarah_copie_2.png?v=1772886695",
    takimarah_freq: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_82.png?v=1773411110",

    extratinrieur_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Extratinrieur_2.png?v=1746298764",
    extratinrieur_freq: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_182.png?v=1748812595",

    mathesis_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Mathesis_onthologique_posoennoial_2_copie.png?v=1772887173",
    mathesis_freq: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/nombre_guide_379.png?v=1773410504"
  };

  function clampStr(v){ return (v == null) ? "" : String(v); }
  function normLang(v){
    var s = clampStr(v).toUpperCase().trim();
    return (s === "FR" || s === "EN" || s === "ES") ? s : DEFAULT_LANG;
  }
  function readLang(){ try { return normLang(localStorage.getItem(STORAGE_KEY)); } catch(e){ return DEFAULT_LANG; } }
  function storeLang(lang){ try { localStorage.setItem(STORAGE_KEY, normLang(lang)); } catch(e){} }
  function canon(txt){ return '<span class="notranslate" translate="no">' + clampStr(txt) + '</span>'; }

  var TERMS = {
    ekho: canon("Êkhö"),
    katuvys: canon("La Katûvýs"),
    katusys: canon("Katûsýs"),
    usoprogalenmestud: canon("Ušôprogalenmestûd"),
    katuvysissence: canon("Katûvýsissence"),
    lulaesirasen: canon("Lulæṣírasen"),
    taxielis: canon("Taxiêlîs"),
    tiqqunbahu: canon("Tiqqunbahu"),
    takimarah: canon("Takimarah"),
    extratinrieur: canon("Extratinrieur"),
    mathesis: canon("Mathêsis ontologique posœnnoïale"),
    katupirsia5: canon("Katûpirsia 5 – La Matrice-substrat"),
    rezonans: canon("RéZonans")
  };

  var UNITS = [
    {
      key: "usoprogalenmestud", name: TERMS.usoprogalenmestud, href: URLS.usoprogalenmestud,
      img: URLS.usoprogalenmestud_img, freqImg: URLS.usoprogalenmestud_freq, freq: "225",
      fr: "Vortex de modulation transitoire entre dimensions et seuils rituels spécifiques.",
      en: "Transitory modulation vortex between dimensions and specific ritual thresholds.",
      es: "Vórtice de modulación transitoria entre dimensiones y umbrales rituales específicos."
    },
    {
      key: "katuvysissence", name: TERMS.katuvysissence, href: URLS.katuvysissence,
      img: URLS.katuvysissence_img, freqImg: URLS.katuvysissence_freq, freq: "193",
      fr: "Densité mémorielle spiralée et matrice régulatrice des intensités.",
      en: "Spiraled memorial density and regulating matrix of intensities.",
      es: "Densidad memorial en espiral y matriz reguladora de las intensidades."
    },
    {
      key: "lulaesirasen", name: TERMS.lulaesirasen, href: URLS.lulaesirasen,
      img: URLS.lulaesirasen_img, freqImg: URLS.lulaesirasen_freq, freq: "136",
      fr: "Moteur de transmutation spiralée et impulsion des basculements d’état.",
      en: "Engine of spiraled transmutation and impulse of state shifts.",
      es: "Motor de transmutación espiral y de impulsión de los cambios de estado."
    },
    {
      key: "taxielis", name: TERMS.taxielis, href: URLS.taxielis,
      img: URLS.taxielis_img, freqImg: URLS.taxielis_freq, freq: "99",
      fr: "Points d’interconnexion entre modalités, seuils et symboles.",
      en: "Interconnection points between modalities, thresholds and symbols.",
      es: "Puntos de interconexión entre modalidades, umbrales y símbolos."
    },
    {
      key: "tiqqunbahu", name: TERMS.tiqqunbahu, href: URLS.tiqqunbahu,
      img: URLS.tiqqunbahu_img, freqImg: URLS.tiqqunbahu_freq, freq: "130",
      fr: "Microstructures répétitives activant les interactions vibratoires.",
      en: "Repetitive micro-structures activating vibratory interactions.",
      es: "Microestructuras repetitivas que activan las interacciones vibratorias."
    },
    {
      key: "takimarah", name: TERMS.takimarah, href: URLS.takimarah,
      img: URLS.takimarah_img, freqImg: URLS.takimarah_freq, freq: "82",
      fr: "Systèmes d’activation des modalités opératives et matrice de canalisation.",
      en: "Systems for activating operative modalities and matrix of channeling.",
      es: "Sistemas de activación de las modalidades operativas y matriz de canalización."
    },
    {
      key: "extratinrieur", name: TERMS.extratinrieur, href: URLS.extratinrieur,
      img: URLS.extratinrieur_img, freqImg: URLS.extratinrieur_freq, freq: "182",
      fr: "Interface vibratoire entre intériorité et extériorité.",
      en: "Vibratory interface between interiority and exteriority.",
      es: "Interfaz vibratoria entre interioridad y exterioridad."
    },
    {
      key: "mathesis", name: TERMS.mathesis, href: URLS.mathesis,
      img: URLS.mathesis_img, freqImg: URLS.mathesis_freq, freq: "379",
      fr: "Structure transductive de propagation du sens.",
      en: "Transductive structure for the propagation of meaning.",
      es: "Estructura transductiva de propagación del sentido."
    }
  ];

  function setSlotText(root, slot, value){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (node) node.textContent = clampStr(value);
  }
  function setSlotHTML(root, slot, value){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (node) node.innerHTML = clampStr(value);
  }
  function setImage(root, slot, url, alt){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.src = clampStr(url || "");
    node.alt = clampStr(alt || "");
  }
  function renderListInto(root, slot, items){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.innerHTML = item;
      node.appendChild(li);
    });
  }
  function renderWordBlocks(root, slot, blocks){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.innerHTML = "";
    (blocks || []).forEach(function(block){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      wrap.innerHTML = '<div class="po-axis-wb__h">' + clampStr(block.head) + '</div><div class="po-axis-wb__t">' + clampStr(block.text) + '</div>';
      node.appendChild(wrap);
    });
  }

  function buildMetaCard(title, mediaUrl, text, klass){
    var media = mediaUrl
      ? '<span class="po-ekho-meta__media" aria-hidden="true"><img class="po-ekho-meta__img" src="' + clampStr(mediaUrl) + '" alt="" loading="lazy" decoding="async" /></span>'
      : "";
    return '<div class="po-ekho-meta__item ' + clampStr(klass || "") + '"><span class="po-ekho-meta__title">' + clampStr(title) + '</span>' + media + '<span class="po-ekho-meta__text">' + clampStr(text) + '</span></div>';
  }

  function buildUnitCards(lang){
    var button = { FR: "Voir la page", EN: "Open page", ES: "Ver la página" }[lang];
    return UNITS.map(function(item){
      return (
        '<article class="po-unit-card">' +
          '<a class="po-unit-card__title" href="' + item.href + '">' + item.name + '</a>' +
          '<div class="po-unit-card__mediawrap">' +
            '<span class="po-unit-card__media"><img class="po-unit-card__img" src="' + item.img + '" alt="" loading="lazy" decoding="async" /></span>' +
            '<span class="po-unit-card__media po-unit-card__media--freq"><img class="po-unit-card__img" src="' + item.freqImg + '" alt="" loading="lazy" decoding="async" /></span>' +
          '</div>' +
          '<div class="po-unit-card__freq"># ' + item.freq + '</div>' +
          '<p class="po-unit-card__desc">' + clampStr(item[lang.toLowerCase()]) + '</p>' +
          '<div class="po-unit-card__linkline"><a href="' + item.href + '">' + clampStr(button) + '</a></div>' +
        '</article>'
      );
    }).join("");
  }

  function content(lang){
    if (lang === "EN") {
      return {
        title: "Êkhö",
        kicker: 'Excerpt from <em>' + TERMS.katupirsia5 + '</em><br />(Transversal totem of autonomous resonance and ecosophic adjustment)',
        h_def: "Operative definition",
        meta_html:
          buildMetaCard("Category", "", "Totem") +
          buildMetaCard("Element", URLS.katuvys_img, "La Katûvýs") +
          buildMetaCard("Internal band", URLS.katusys_img, "Katûsýs"),
        def_short: TERMS.ekho + ' names a totem of autonomous resonance that crosses a milieu and adjusts it, turning reverberation into active modulation.',
        def_long:
          '<p>' + TERMS.ekho + ' names a threshold-quality of resonance: it crosses a field without dissolving into it, touches it without being trapped, and retunes it without hardening it. In the ecology of ' + TERMS.katupirsia5 + ', this quality is called ecosophic: an intelligence of milieu attentive to intensities, passages, tensions and releases.</p>' +
          '<p>Its operative range is explicit: transform, modulate, amplify, reduce according to the instant. ' + TERMS.ekho + ' is therefore not a simple echo and not a decorative emblem. It is a transversal marker that accompanies several internal organs of ' + TERMS.katuvys + ' wherever the field asks for a fine regulation rather than a rigid control.</p>' +
          '<p>The Greek anamnesis deepens the word without replacing its canonical status: ἠχώ contributes wave-propagation, ἔχω contributes holding and keeping. Together they give an “held wave”, capable of crossing and adjusting. That is why ' + TERMS.ekho + ' appears where a passage must remain alive, traversable and governable.</p>',
        h_related: "Organs under the totem " + 'Êkhö',
        related_html: buildUnitCards(lang),
        h_features: "Operative dynamics",
        features: [
          TERMS.ekho + ' adjusts a milieu through active resonance: transform, modulate, amplify, reduce.',
          'It appears when the field reacts too quickly by reflexive return and needs a finer regulation.',
          'Its action belongs to threshold situations, passages, integrations, tensions and recompositions.',
          'It is attached to several internal organs of ' + TERMS.katuvys + ' gathered in ' + TERMS.katusys + '.',
          TERMS.ekho + ' works on intensities of milieu rather than on discursive explanation.'
        ],
        h_questions: "Applications / markers",
        questions: [
          'Is the situation asking for modulation rather than force?',
          'Should the charge be amplified, reduced, transformed or simply held for a moment?',
          'Does the field remain traversable, or is it closing into reflex and rigidity?',
          'Which organ is currently calling the totem: ' + TERMS.usoprogalenmestud + ', ' + TERMS.taxielis + ', ' + TERMS.tiqqunbahu + ', ' + TERMS.takimarah + ', ' + TERMS.extratinrieur + ', ' + TERMS.mathesis + ' or ' + TERMS.katuvysissence + '?'
        ],
        example_title: "Ex.",
        example: 'A threshold is saturating, yet the passage must remain habitable: ' + TERMS.ekho + ' is invoked to hold the wave, reduce the overload and let transformation remain active.',
        h_family: "Systemic links",
        family_1: '<p><strong>With ' + TERMS.katuvys + ':</strong> ' + TERMS.ekho + ' is a transversal totem. It is not one more organ inside the matrix-substrate; it marks the zones where a living resonance must accompany the internal organs of ' + TERMS.katuvys + '.</p>',
        family_2: '<p><strong>With ' + TERMS.katusys + ':</strong> the totem accompanies eight internal organs—' + TERMS.lulaesirasen + ', ' + TERMS.taxielis + ', ' + TERMS.tiqqunbahu + ', ' + TERMS.takimarah + ', ' + TERMS.mathesis + ', ' + TERMS.extratinrieur + ', ' + TERMS.katuvysissence + ', ' + TERMS.usoprogalenmestud + '—each of them sharing the same element ' + TERMS.katuvys + ' and the same totem ' + TERMS.ekho + '.</p>',
        h_wordbuild: "Construction of the term",
        word_blocks: [
          { head: "1) ἠχώ", text: "Greek stratum of propagation, echo, reverberation, circulating wave." },
          { head: "2) ἔχω", text: "Greek stratum of holding, keeping, maintaining, staying in a state." },
          { head: "3) Addition synchrêtique", text: "Wave + holding gives a held wave: a resonance capable of adjustment rather than mere return." }
        ],
        word_notes: [
          'Canonical status: transverse totem, epicene and invariable.',
          'Elemental anchoring: ' + TERMS.katuvys + '.',
          'Main operative family: threshold, passage, modulation, ecosophic adjustment.',
          'The canonical page keeps ' + TERMS.ekho + ' in French across all languages.'
        ],
        cta_translate: "Proposer une traduction du concept"
      };
    }

    if (lang === "ES") {
      return {
        title: "Êkhö",
        kicker: 'Extracto de <em>' + TERMS.katupirsia5 + '</em><br />(Tótem transversal de resonancia autónoma y ajuste ecosófico)',
        h_def: "Definición operativa",
        meta_html:
          buildMetaCard("Categoría", "", "Tótem") +
          buildMetaCard("Elemento", URLS.katuvys_img, "La Katûvýs") +
          buildMetaCard("Banda interna", URLS.katusys_img, "Katûsýs"),
        def_short: TERMS.ekho + ' nombra un tótem de resonancia autónoma que atraviesa un medio y lo ajusta, convirtiendo el retumbo en modulación activa.',
        def_long:
          '<p>' + TERMS.ekho + ' nombra una cualidad umbral de la resonancia: atraviesa un campo sin disolverse en él, lo toca sin quedar presa y lo reajusta sin endurecerlo. En la ecología de ' + TERMS.katupirsia5 + ', esta cualidad se dice ecosófica: una inteligencia del medio atenta a intensidades, pasos, tensiones y relajamientos.</p>' +
          '<p>Su gama operativa es explícita: transformar, modular, amplificar, reducir según el instante. ' + TERMS.ekho + ' no es, pues, un simple eco ni un emblema decorativo. Es un marcador transversal que acompaña a varios órganos internos de ' + TERMS.katuvys + ' allí donde el campo exige una regulación fina y no un control rígido.</p>' +
          '<p>La anámnesis griega densifica el término sin sustituir su estatuto canónico: ἠχώ aporta propagación ondulatoria, ἔχω aporta sostén y tenencia. Juntas forman una “onda sostenida”, capaz de atravesar y ajustar. Por eso ' + TERMS.ekho + ' aparece allí donde un paso debe seguir vivo, habitable y gobernable.</p>',
        h_related: "Órganos bajo el tótem " + 'Êkhö',
        related_html: buildUnitCards(lang),
        h_features: "Dinámicas operativas",
        features: [
          TERMS.ekho + ' ajusta un medio por resonancia activa: transformar, modular, amplificar, reducir.',
          'Aparece cuando el campo responde demasiado rápido por reflejo y necesita una regulación más fina.',
          'Su acción pertenece a situaciones de umbral, paso, integración, tensión y recomposición.',
          'Se vincula a varios órganos internos de ' + TERMS.katuvys + ' reunidos en ' + TERMS.katusys + '.',
          TERMS.ekho + ' trabaja sobre las intensidades del medio más que sobre la explicación discursiva.'
        ],
        h_questions: "Aplicaciones / referencias",
        questions: [
          '¿La situación pide modulación en lugar de fuerza?',
          '¿La carga debe amplificarse, reducirse, transformarse o sencillamente sostenerse un momento?',
          '¿El campo sigue siendo atravesable o se cierra en reflejo y rigidez?',
          '¿Qué órgano está llamando ahora al tótem: ' + TERMS.usoprogalenmestud + ', ' + TERMS.taxielis + ', ' + TERMS.tiqqunbahu + ', ' + TERMS.takimarah + ', ' + TERMS.extratinrieur + ', ' + TERMS.mathesis + ' o ' + TERMS.katuvysissence + '?'
        ],
        example_title: "Ej.",
        example: 'Un umbral se satura, aunque el paso debe seguir habitable: ' + TERMS.ekho + ' es convocado para sostener la onda, reducir la sobrecarga y dejar que la transformación permanezca activa.',
        h_family: "Vínculos sistémicos",
        family_1: '<p><strong>Con ' + TERMS.katuvys + ':</strong> ' + TERMS.ekho + ' es un tótem transversal. No es un órgano más dentro de la matriz-substrato; señala las zonas donde una resonancia viva debe acompañar a los órganos internos de ' + TERMS.katuvys + '.</p>',
        family_2: '<p><strong>Con ' + TERMS.katusys + ':</strong> el tótem acompaña a ocho órganos internos—' + TERMS.lulaesirasen + ', ' + TERMS.taxielis + ', ' + TERMS.tiqqunbahu + ', ' + TERMS.takimarah + ', ' + TERMS.mathesis + ', ' + TERMS.extratinrieur + ', ' + TERMS.katuvysissence + ', ' + TERMS.usoprogalenmestud + '—que comparten el mismo elemento ' + TERMS.katuvys + ' y el mismo tótem ' + TERMS.ekho + '.</p>',
        h_wordbuild: "Construcción del término",
        word_blocks: [
          { head: "1) ἠχώ", text: "Estrato griego de propagación, eco, repercusión, onda en circulación." },
          { head: "2) ἔχω", text: "Estrato griego de tenencia, sostén, mantenimiento, permanencia en un estado." },
          { head: "3) Adición sinchrêtica", text: "Onda + tenencia da una onda sostenida: una resonancia capaz de ajustar en vez de limitarse a devolver." }
        ],
        word_notes: [
          'Estatuto canónico: tótem transversal, epiceno e invariable.',
          'Anclaje elemental: ' + TERMS.katuvys + '.',
          'Familia operativa principal: umbral, paso, modulación, ajuste ecosófico.',
          'La página canónica conserva ' + TERMS.ekho + ' en francés en las tres lenguas.'
        ],
        cta_translate: "Proposer une traduction du concept"
      };
    }

    return {
      title: "Êkhö",
      kicker: 'Extrait de <em>' + TERMS.katupirsia5 + '</em><br />(Totem transversal de résonance autonome et d’ajustement écosophique)',
      h_def: "Définition opérative",
      meta_html:
        buildMetaCard("Catégorie", "", "Totem") +
        buildMetaCard("Élément", URLS.katuvys_img, "La Katûvýs") +
        buildMetaCard("Bande interne", URLS.katusys_img, "Katûsýs"),
      def_short: TERMS.ekho + ' nomme un totem de résonance autonome qui traverse un milieu et l’ajuste, en convertissant le retentissement en modulation active.',
      def_long:
        '<p>' + TERMS.ekho + ' nomme une qualité de résonance qui sait habiter le seuil : elle traverse un champ sans s’y dissoudre, le touche sans s’y enfermer, et le réaccorde sans le rigidifier. Dans l’écologie de ' + TERMS.katupirsia5 + ', cette qualité est dite écosophique : une intelligence du milieu attentive aux intensités, aux passages, aux tensions et aux relâchements.</p>' +
        '<p>Sa gamme opérative est explicite : transformer, moduler, amplifier, réduire selon l’instant. ' + TERMS.ekho + ' n’est donc ni un simple écho, ni un emblème décoratif. C’est un marqueur transversal qui accompagne plusieurs organes internes de ' + TERMS.katuvys + ' là où le champ exige une régulation fine plutôt qu’un contrôle rigide.</p>' +
        '<p>L’anamnèse grecque densifie le terme sans remplacer son statut canonique : ἠχώ apporte la propagation ondulatoire, ἔχω apporte la tenue et le maintien. Ensemble, elles composent une “onde tenue”, capable de traverser et d’ajuster. C’est pourquoi ' + TERMS.ekho + ' apparaît là où un passage doit rester vivant, habitable et gouvernable.</p>',
      h_related: "Organes portés par le totem Êkhö",
      related_html: buildUnitCards(lang),
      h_features: "Dynamiques opératives",
      features: [
        TERMS.ekho + ' ajuste un milieu par résonance active : transformer, moduler, amplifier, réduire.',
        'Il apparaît quand le champ “répond” trop vite par renvoi réflexe et demande une régulation plus fine.',
        'Son action appartient aux situations de seuil, de passage, d’intégration, de tension et de recomposition.',
        'Il accompagne plusieurs organes internes de ' + TERMS.katuvys + ' réunis dans ' + TERMS.katusys + '.',
        TERMS.ekho + ' travaille sur les intensités du milieu plutôt que sur l’explication discursive.'
      ],
      h_questions: "Applications / repères",
      questions: [
        'La situation demande-t-elle de la modulation plutôt que de la force ?',
        'La charge doit-elle être amplifiée, réduite, transformée, ou simplement tenue un moment ?',
        'Le champ reste-t-il traversable, ou se ferme-t-il dans le réflexe et la rigidité ?',
        'Quel organe appelle maintenant le totem : ' + TERMS.usoprogalenmestud + ', ' + TERMS.taxielis + ', ' + TERMS.tiqqunbahu + ', ' + TERMS.takimarah + ', ' + TERMS.extratinrieur + ', ' + TERMS.mathesis + ' ou ' + TERMS.katuvysissence + ' ?'
      ],
      example_title: "Ex.",
      example: 'Un seuil se sature, mais le passage doit rester habitable : ' + TERMS.ekho + ' est appelé pour tenir l’onde, réduire la surcharge et laisser la transformation demeurer active.',
      h_family: "Liens systémiques",
      family_1: '<p><strong>Avec ' + TERMS.katuvys + ' :</strong> ' + TERMS.ekho + ' est un totem transversal. Il n’est pas un organe de plus dans la matrice-substrat ; il marque les zones où une résonance vivante doit accompagner les organes internes de ' + TERMS.katuvys + '.</p>',
      family_2: '<p><strong>Avec ' + TERMS.katusys + ' :</strong> le totem accompagne huit organes internes — ' + TERMS.lulaesirasen + ', ' + TERMS.taxielis + ', ' + TERMS.tiqqunbahu + ', ' + TERMS.takimarah + ', ' + TERMS.mathesis + ', ' + TERMS.extratinrieur + ', ' + TERMS.katuvysissence + ', ' + TERMS.usoprogalenmestud + ' — qui partagent le même élément ' + TERMS.katuvys + ' et le même totem ' + TERMS.ekho + '.</p>',
      h_wordbuild: "Construction du terme",
      word_blocks: [
        { head: "1) ἠχώ", text: "Strate grecque de propagation, d’écho, de retentissement, d’onde en circulation." },
        { head: "2) ἔχω", text: "Strate grecque de tenue, de garde, de maintien, de persistance dans un état." },
        { head: "3) Addition synchrêtique", text: "Onde + tenue donne une onde tenue : une résonance capable d’ajuster plutôt que de seulement renvoyer." }
      ],
      word_notes: [
        'Statut canonique : totem transversal, épicène et invariable.',
        'Ancrage élémentaire : ' + TERMS.katuvys + '.',
        'Famille opérative principale : seuil, passage, modulation, ajustement écosophique.',
        'La page canonique conserve ' + TERMS.ekho + ' en français dans les trois langues.'
      ],
      cta_translate: "Proposer une traduction du concept"
    };
  }

  function applyLang(lang){
    lang = normLang(lang);
    storeLang(lang);

    var root = document.querySelector('.po-axis-section[data-po-lex-id="ekho"]');
    if (!root) return;

    var F = content(lang);
    setImage(root, "title_img", URLS.title, F.title);
    setSlotText(root, "title", F.title);
    setSlotHTML(root, "kicker", F.kicker);
    setSlotText(root, "h_def", F.h_def);
    setSlotHTML(root, "meta_cluster", F.meta_html);
    setSlotHTML(root, "def_short", F.def_short);
    setSlotHTML(root, "def_long", F.def_long);
    setSlotText(root, "h_related", F.h_related);
    setSlotHTML(root, "related_cards", F.related_html);
    setSlotText(root, "h_features", F.h_features);
    setSlotText(root, "hint_fold", {FR:"déplier",EN:"expand",ES:"desplegar"}[lang]);
    renderListInto(root, "features", F.features);
    setSlotText(root, "h_questions", F.h_questions);
    setSlotText(root, "hint_fold2", {FR:"déplier",EN:"expand",ES:"desplegar"}[lang]);
    renderListInto(root, "questions", F.questions);
    setSlotHTML(root, "example_box", '<p><strong>' + F.example_title + '</strong> ' + F.example + '</p>');
    setSlotText(root, "h_family", F.h_family);
    setSlotText(root, "hint_fold3", {FR:"déplier",EN:"expand",ES:"desplegar"}[lang]);
    setSlotHTML(root, "family_1", F.family_1);
    setSlotHTML(root, "family_2", F.family_2);
    setSlotText(root, "h_wordbuild", F.h_wordbuild);
    renderWordBlocks(root, "wordbuild_blocks", F.word_blocks);
    renderListInto(root, "wordbuild_notes", F.word_notes);
    setSlotText(root, "cta_translate", F.cta_translate);

    root.querySelectorAll('.po-langbtn').forEach(function(btn){
      var isActive = btn.getAttribute('data-po-lang') === lang;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function bindButtons(){
    document.querySelectorAll('.po-axis-section[data-po-lex-id="ekho"] .po-langbtn').forEach(function(btn){
      btn.addEventListener('click', function(){
        applyLang(btn.getAttribute('data-po-lang'));
      });
    });
  }

  function keepProtected(){
    var root = document.querySelector('.po-axis-section[data-po-lex-id="ekho"]');
    if (!root || !window.MutationObserver) return;
    if (root.__po_ekho_observer) return;
    root.__po_ekho_observer = true;
    var mo = new MutationObserver(function(){
      root.querySelectorAll('.notranslate').forEach(function(node){
        node.setAttribute('translate', 'no');
      });
    });
    mo.observe(root, { childList:true, subtree:true, attributes:true, characterData:true });
  }

  function init(){
    bindButtons();
    applyLang(readLang());
    keepProtected();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.PoK5EkhoTextsFR_EN_ES_20260401 = {
    init: init,
    setLang: applyLang,
    getLang: readLang,
    normLang: normLang
  };
})();
